import React from 'react';
import { Trash2, ArrowLeft, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import { TopNav } from '../components/layout/TopNav';
import { EBTWICBanner } from '../components/layout/EBTWICBanner';
import { TrustBadge } from '../components/ui/TrustBadge';
import { useCart } from '../hooks/useCart';
import { motion, AnimatePresence } from 'framer-motion';
export function CartPage() {
  const {
    items,
    updateQuantity,
    removeFromCart,
    subtotal,
    ebtTotal
  } = useCart();
  const deliveryFee = subtotal > 35 ? 0 : 5.99;
  const total = subtotal + deliveryFee;
  return <div className="min-h-screen bg-[#FAF8F5]" data-id="element-269">
      <EBTWICBanner data-id="element-270" />
      <TopNav data-id="element-271" />

      <main className="max-w-7xl mx-auto px-6 py-12" data-id="element-272">
        <div className="mb-8" data-id="element-273">
          <Link to="/" className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-4" data-id="element-274">
            <ArrowLeft className="w-5 h-5" data-id="element-275" />
            <span className="font-medium" data-id="element-276">Continue Shopping</span>
          </Link>
          <h1 className="text-4xl font-bold text-gray-900" data-id="element-277">Your Cart</h1>
        </div>

        {items.length > 0 ? <div className="grid lg:grid-cols-3 gap-8" data-id="element-278">
            <div className="lg:col-span-2 space-y-4" data-id="element-279">
              <AnimatePresence initial={false} data-id="element-280">
                {items.map(item => <motion.div key={item.product.id} layout initial={{
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={{
              opacity: 0,
              height: 0
            }} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex gap-6" data-id="element-281">
                    <div className="w-32 h-32 bg-gray-50 rounded-xl flex-shrink-0 overflow-hidden" data-id="element-282">
                      <img src={item.product.image} alt={item.product.altText} className="w-full h-full object-cover" data-id="element-283" />
                    </div>

                    <div className="flex-grow flex flex-col justify-between" data-id="element-284">
                      <div data-id="element-285">
                        <div className="flex justify-between items-start mb-2" data-id="element-286">
                          <div data-id="element-287">
                            <h3 className="font-bold text-gray-900 text-lg mb-1" data-id="element-288">
                              {item.product.name}
                            </h3>
                            <div className="flex gap-2" data-id="element-289">
                              {item.product.isWIC && <TrustBadge type="WIC" size="sm" data-id="element-290" />}
                              {item.product.isEBT && <TrustBadge type="EBT" size="sm" data-id="element-291" />}
                            </div>
                          </div>
                          <button onClick={() => removeFromCart(item.product.id)} className="text-gray-400 hover:text-red-500 p-2 transition-colors" aria-label="Remove item" data-id="element-292">
                            <Trash2 className="w-5 h-5" data-id="element-293" />
                          </button>
                        </div>
                      </div>

                      <div className="flex items-center justify-between mt-4" data-id="element-294">
                        <span className="font-bold text-[#1E40AF] text-xl" data-id="element-295">
                          ${(item.product.price * item.quantity).toFixed(2)}
                        </span>

                        <div className="flex items-center gap-4 bg-gray-50 rounded-xl p-2" data-id="element-296">
                          <button onClick={() => updateQuantity(item.product.id, item.quantity - 1)} className="w-9 h-9 flex items-center justify-center bg-white rounded-lg shadow-sm text-gray-600 font-bold hover:bg-gray-100 transition-colors" aria-label="Decrease quantity" data-id="element-297">
                            -
                          </button>
                          <span className="text-base font-semibold w-8 text-center" data-id="element-298">
                            {item.quantity}
                          </span>
                          <button onClick={() => updateQuantity(item.product.id, item.quantity + 1)} className="w-9 h-9 flex items-center justify-center bg-white rounded-lg shadow-sm text-gray-600 font-bold hover:bg-gray-100 transition-colors" aria-label="Increase quantity" data-id="element-299">
                            +
                          </button>
                        </div>
                      </div>
                    </div>
                  </motion.div>)}
              </AnimatePresence>
            </div>

            <div className="lg:col-span-1" data-id="element-300">
              <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 sticky top-24" data-id="element-301">
                <h2 className="font-bold text-gray-900 text-2xl mb-6" data-id="element-302">
                  Order Summary
                </h2>

                <div className="space-y-4 text-base mb-6" data-id="element-303">
                  <div className="flex justify-between text-gray-600" data-id="element-304">
                    <span data-id="element-305">Subtotal</span>
                    <span className="font-semibold" data-id="element-306">
                      ${subtotal.toFixed(2)}
                    </span>
                  </div>
                  <div className="flex justify-between text-gray-600" data-id="element-307">
                    <span data-id="element-308">Delivery</span>
                    {deliveryFee === 0 ? <span className="text-[#2563EB] font-bold" data-id="element-309">FREE</span> : <span className="font-semibold" data-id="element-310">
                        ${deliveryFee.toFixed(2)}
                      </span>}
                  </div>
                  {ebtTotal > 0 && <div className="flex justify-between text-[#2563EB] bg-blue-50 p-3 rounded-lg" data-id="element-311">
                      <span className="font-semibold" data-id="element-312">EBT Eligible Amount</span>
                      <span className="font-bold" data-id="element-313">${ebtTotal.toFixed(2)}</span>
                    </div>}
                </div>

                <div className="border-t border-gray-200 pt-6 mb-6" data-id="element-314">
                  <div className="flex justify-between items-end" data-id="element-315">
                    <span className="font-bold text-gray-900 text-lg" data-id="element-316">
                      Total
                    </span>
                    <span className="font-bold text-gray-900 text-3xl" data-id="element-317">
                      ${total.toFixed(2)}
                    </span>
                  </div>
                </div>

                <button className="w-full bg-[#DC2626] text-white font-bold py-4 rounded-xl shadow-lg hover:bg-[#B91C1C] transition-colors flex items-center justify-center gap-2 mb-4" data-id="element-318">
                  <ShieldCheck className="w-5 h-5" data-id="element-319" />
                  Secure Checkout
                </button>

                <div className="flex justify-center pt-4 border-t border-gray-100" data-id="element-320">
                  <TrustBadge type="USDA" data-id="element-321" />
                </div>
              </div>
            </div>
          </div> : <div className="flex flex-col items-center justify-center py-20 text-center" data-id="element-322">
            <div className="w-32 h-32 bg-red-50 rounded-full flex items-center justify-center mb-8" data-id="element-323">
              <span className="text-6xl" data-id="element-324">🛒</span>
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-325">
              Your cart is empty
            </h2>
            <p className="text-gray-500 mb-10 max-w-md text-lg" data-id="element-326">
              Looks like you haven't added any groceries yet. Start shopping to
              fill your pantry!
            </p>
            <Link to="/" className="bg-[#DC2626] text-white px-10 py-4 rounded-xl font-bold shadow-lg hover:bg-[#B91C1C] transition-colors text-lg" data-id="element-327">
              Start Shopping
            </Link>
          </div>}
      </main>
    </div>;
}